// management-frontend/src/context/testConnection.js

import apiServices from "../services/apiServices";

class TestConnection {
  async Test(host, port, user, password, database) {
    const api = new apiServices();
    try {
      // Envia os dados do sistema para a API
      const response = await api.post("/TestConnection", {
        host: host,
        port: port,
        user: user,
        password: password,
        database: database,
      });

      if (response.success) {
        return { success: true, message: "✅ Conexão bem-sucedida!" };
      } else {
        return { success: false, message: "❌ Falha na conexão." };
      }
    } catch (error) {
      return {
        success: false,
        message: "⚠️ Erro ao testar conexão: " + (error.response?.data?.message || error.message),
      };
    }
  }
}

export default TestConnection;
